const loadProductProfile = (data) => ({
  productProfileId: data.id || null,
  product_profile_name: data.name,
  description: data.description,
  user_scan_script: data.user_scan_script,
  lumia_lase_script: data.lumia_lase_script,
  job_parameters: JSON.stringify(data.parameters),
})

export default loadProductProfile
